// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 749 ? "group-restorant" : chunkId) + "." + {"177":"864b4d84","530":"f0448d31","749":"55de06d1","822":"07af5b2e","865":"12e401d2"}[chunkId] + ".js";
};